import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import "typeface-poppins";
import "typeface-raleway";


const Page2 = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      sx={{
        backgroundColor: "black",
        height: "100vh",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        overflow: "hidden",
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          "& > div": {
            position: "absolute",
            zIndex: 0,
            opacity: isHovered ? 1 : 0,
            transform: isHovered ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
          },
        }}
      >
        {/* Vertical Lines */}
        <Box
          sx={{
            left: "10%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF15, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "20%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF25, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "30%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF30, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "40%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF30, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "50%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF30, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "60%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF30, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "70%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF30, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "80%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF25, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            left: "90%",
            width: "1px",
            height: "100%",
            background: "linear-gradient(to bottom, #FFFFFF00, #FFFFFF15, #FFFFFF00)",
          }}
        />

        {/* Horizontal Lines */}
        <Box
          sx={{
            top: "10%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF12, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "20%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF25, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "30%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF20, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "40%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF20, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "50%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF20, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "60%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF20, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "70%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF27, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "80%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF25, #FFFFFF00)",
          }}
        />
        <Box
          sx={{
            top: "90%",
            width: "100%",
            height: "1px",
            background: "linear-gradient(to right, #FFFFFF00, #FFFFFF12, #FFFFFF00)",
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: "medium",
            fontSize: "32px",
            fontFamily: "Raleway",
            opacity: isHovered ? 1 : 0,
            transform: isHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out",
            transitionDelay: "0.6s",
          }}
        >
          <span style={{ color: "#7A7A7A" }}> Achieve sustainability with</span>
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: "medium",
            marginTop: "10px",
            fontSize: "32px",
            fontFamily: "Raleway",
            color: "#FFFFFF",
            opacity: isHovered ? 1 : 0,
            transform: isHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 0.2s",
            transitionDelay: "0.8s",
          }}
        >
          TowerWatch
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "15px",
            marginTop: "20px",
            maxWidth: "400px",
            opacity: isHovered ? 0.8 : 0,
            transform: isHovered ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 0.4s",
            transitionDelay: "1s",
            fontWeight: "medium",
            fontFamily: "Raleway",
            color: "#7A7A7A",
          }}
        >
          TowerWatch aligns with the United Nations Sustainable Development
          Goals by optimizing energy use and reducing environmental impact,
          supporting a cleaner, greener future.
        </Typography>
      </Box>
    </Box>
  );
};

export default Page2;
